import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = { class: "w-full flex flex-col" };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = { key: 0 };
const _hoisted_4 = { class: "border border-surface-200 dark:border-surface-700 rounded m-2 p-4" };
const _hoisted_5 = { class: "mb-4" };
const _hoisted_6 = { class: "relative mx-auto" };
const _hoisted_7 = ["src", "alt"];
const _hoisted_8 = { key: 1 };
const _hoisted_9 = ["src"];
const _hoisted_10 = ["innerHTML"];
import ViewVideo from "@/components/uikit/platformComponents/ViewVideo.vue";
import { Carousel } from "primevue";
import { ref } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'BlockViewer',
    props: {
        blocks: {
            type: Array,
            default: () => []
        }
    },
    setup(__props) {
        const props = __props;
        const list = ref(props.blocks);
        function getBlockData(block) {
            if (block.type == "text") {
                return block.content;
            }
            else if (block.type == "video") {
                return block.url;
            }
        }
        function getImageBlockData(block) {
            return block.url;
        }
        function getCarouselBlockData(block) {
            return block.urls;
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (listItem, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        style: _normalizeStyle({
                            background: listItem.backgroundColor || 'transparent',
                            paddingBottom: (listItem.visualIndent || 0) + 'px'
                        })
                    }, [
                        (listItem.display !== false)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                (listItem.type == 'carousel')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                        _createVNode(_unref(Carousel), {
                                            value: getCarouselBlockData(listItem),
                                            "num-visible": 3,
                                            "num-scroll": 3
                                        }, {
                                            item: _withCtx((slotProps) => [
                                                _createElementVNode("div", _hoisted_4, [
                                                    _createElementVNode("div", _hoisted_5, [
                                                        _createElementVNode("div", _hoisted_6, [
                                                            _createElementVNode("img", {
                                                                src: slotProps.data,
                                                                alt: slotProps.data.name,
                                                                class: "w-full rounded"
                                                            }, null, 8, _hoisted_7)
                                                        ])
                                                    ])
                                                ])
                                            ]),
                                            _: 1
                                        }, 8, ["value"])
                                    ]))
                                    : (listItem.type == 'image')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                            _createElementVNode("img", {
                                                src: getImageBlockData(listItem),
                                                class: "w-full rounded"
                                            }, null, 8, _hoisted_9)
                                        ]))
                                        : (listItem.type == 'text')
                                            ? (_openBlock(), _createElementBlock("div", {
                                                key: 2,
                                                innerHTML: getBlockData(listItem)
                                            }, null, 8, _hoisted_10))
                                            : (listItem.type == 'video')
                                                ? (_openBlock(), _createBlock(ViewVideo, {
                                                    key: 3,
                                                    link: getBlockData(listItem)
                                                }, null, 8, ["link"]))
                                                : _createCommentVNode("", true)
                            ]))
                            : _createCommentVNode("", true)
                    ], 4));
                }), 128))
            ]));
        };
    }
});
